<template>

  <div class="main-top">

    <div class="search-wrap">
      <div style="flex:1">
        <search-from>
          <template slot="default">
            <slot name="default"></slot>
          </template>
          <template slot="shrink">
            <slot name="shrink"></slot>
          </template>
        </search-from>
        <slot name="searchForm"></slot>
      </div>
      <div class="query-wrap">

        <div>
          <div style="display: flex;align-items: center;">

            <slot name="query"></slot>
            <div style="width: 5px"></div>

            <!-- <f-button v-if="show==false" icon="unfold" @click="handleClick(true)" :icon-size="14">展开</f-button>
            <f-button v-if="show==true" icon="packup" @click="handleClick(false)" :icon-size="14">收起</f-button> -->
            <div v-if="!show && !hideExpand" @click="handleClick(true)" style="cursor: pointer">
              <span style="padding-left:2px">{{$t('展开')}}</span>
              <i class="el-icon-arrow-down"></i>

              <!--            <img style="width:14px;height:7px;cursor: pointer;transform:rotate(180deg)" src="@/assets/images/arrow-up.png" alt>-->
            </div>
            <div v-if="show && !hideExpand" @click="handleClick(false)"  style="cursor: pointer">
              <span style="padding-left:2px">{{$t('收起')}}</span>
              <i class="el-icon-arrow-up"></i>
              <!--            <img style="width:14px;height:7px;cursor: pointer;" src="@/assets/images/arrow-up.png" alt>-->
            </div>
            <div v-if="hideExpand" style="width: 15px"></div>


          </div>

        </div>
      </div>
    </div>
    <!-- <el-row class="elRow">
      <img v-if="show==false" style="width:50px;height:24px;cursor: pointer;" src="@/assets/images/arrow-down.png" @click="handleClick(true)" alt />
      <img v-if="show==true"  style="width:50px;height:24px;cursor: pointer;" src="@/assets/images/arrow-up.png"  @click="handleClick(false)" alt />
    </el-row> -->
  </div>


</template>

<script>
import {EventBus} from '../../utils/event-bus';

export default {
  name: "index",
  data() {
    return {show: false}
  },
  props: {
    value: {
      type: Boolean,
      default: false

    },
    hideExpand:{
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick(state) {
      this.show = state;
      this.$emit("input", this.show);
      this.$nextTick(() => {
        var height = $(".main-top").outerHeight(true);
        this.$emit('searchBorderClick', height)
      })
    }
  }

}
</script>

<style scoped lang="scss">
.tips {
  color: #785D06;
  text-align: center;
  text-decoration: #086BAF;
  margin-left: -20px;
  margin-right: 10px;
  cursor: pointer;
}

.search-wrap {
  display: flex;
  justify-content: space-between;
}

// 查询重置

.query-wrap {
  width: 262px;
  //margin-left: 24px;
  display: flex;
  justify-content: flex-end;
  color:#0364ac;
  //align-items: center;
  padding-right: 10px;
  padding-top: 15px;
  font-size: 14px;

}

.elRow {
  margin-left: 16px;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #0066FF;
  line-height: 32px;
  height: 32px;
  cursor: pointer;

  img {
    margin-top: -10px;
  }
}
[data-theme="theme1"]{
  .query-wrap {
    color:#00f0e9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchFormWrap/index.vue